export default {
	state: () => ({
		menuArr: [
			{
				title: "SDK",
				icon: "at",
				to: "sdk",
				children: [
					{
						title: "Logo",
						icon: "at",
						to: "#sdklogo",
						codePropToMatch: "createLogoJS",
					},
					{
						title: "Splash Screen",
						icon: "image-size-select-actual",
						to: "#splashscreen",
						codePropToMatch: "splashScreen",
					},
					{
						title: "Colors",
						icon: "eyedropper-variant",
						to: "#colors",
						codePropToMatch: "colors",
					},
					{
						title: "Font",
						icon: "format-text",
						to: "#font",
						codePropToMatch: "font",
					},
					{
						title: "Language",
						icon: "web",
						to: "#language",
						codePropToMatch: "locale",
					},
					{
						title: "Developer",
						icon: "alarm-light",
						disabled: process.env.NODE_ENV !== "development",
						to: "#developer",
						codePropToMatch: "developer",
					},
				],
			},
			{
				title: "Email Thumbnail",
				icon: "image-outline",
				to: "emailthumbnail",
				children: [
					{
						title: "Settings",
						icon: "cog-outline",
						to: "#settings",
						codePropToMatch: "document",
					},
				],
			},
			{
				title: "Email Preview",
				icon: "email-search-outline",
				to: "emailpreview",
				children: [
					{
						title: "Header",
						icon: "border-top-variant",
						to: "#header",
						codePropToMatch: "header",
					},
					{
						title: "Settings",
						icon: "cog-outline",
						to: "#settings",
						codePropToMatch: "settings",
					},
				],
			},
			{
				title: "Email Editor",
				icon: "email-edit-outline",
				to: "emaileditor",
				children: [
					{
						title: "Header",
						icon: "border-top-variant",
						to: "#header",
						codePropToMatch: "header",
					},
					{
						title: "Text Insert",
						icon: "format-text",
						to: "#text-insert",
						codePropToMatch: "textInsert",
					},
					{
						title: "Elements",
						icon: "card-plus-outline",
						to: "#elements",
						codePropToMatch: "elements",
					},
					{
						title: "External Elements",
						icon: "card-multiple",
						to: "#external-elements",
						codePropToMatch: "externalElements",
					},
					{
						title: "Block Libraries",
						icon: "database-edit-outline",
						to: "#block-libraries",
						codePropToMatch: "blockLibraries",
					},
					{
						title: "Custom Fonts",
						icon: "format-font",
						to: "#custom-fonts",
						codePropToMatch: "fontFiles",
					},
					{
						title: "Addons",
						icon: "puzzle-outline",
						to: "#addons",
						codePropToMatch: "addons",
					},
					{
						title: "Settings",
						icon: "cog-outline",
						to: "#settings",
						codePropToMatch: "autoSaveInterval",
					},
				],
			},
			{
				title: "Gallery",
				icon: "image",
				to: "gallery",
				children: [
					{
						title: "Folder Tree",
						icon: "folder",
						to: "#folder",
						codePropToMatch: "folder",
					},
					{
						title: "Settings",
						icon: "cog-outline",
						to: "#settings",
						codePropToMatch: "settings",
					},
				],
			},
			{
				title: "Variable Editor",
				icon: "application-variable-outline",
				to: "variableeditor",
				children: [
					{
						title: "Variables To Edit",
						icon: "variable",
						to: "#variablestoedit",
						codePropToMatch: "variablesToEdit",
					},
					{
						title: "Header",
						icon: "border-top-variant",
						to: "#header",
						codePropToMatch: "header",
					},
					{
						title: "Footer",
						icon: "border-bottom-variant",
						to: "#footer",
						codePropToMatch: "footer",
					},
					{
						title: "Custom Fonts",
						icon: "format-font",
						to: "#custom-fonts",
						codePropToMatch: "fontFiles",
					},
					{
						title: "Text Insert",
						icon: "format-text",
						to: "#text-insert",
						codePropToMatch: "textInsert",
					},
				],
			},
			{
				title: "Email HTML Import Plugin",
				icon: "code-json",
				to: "htmlimportplugin",
				children: [
					{
						title: "Header",
						icon: "border-top-variant",
						to: "#header",
						codePropToMatch: "header",
					},
				],
			},
			{
				title: "Email HTML Generator",
				icon: "xml",
				to: "htmlgenerator",
				children: [
					{
						title: "Settings",
						icon: "cog-outline",
						to: "#settings",
						codePropToMatch: "document",
					},
				],
			},
			{
				title: "Landing page HTML Generator",
				icon: "form-select",
				to: "landingpagehtmlgenerator",
				children: [
					{
						title: "Settings",
						icon: "cog-outline",
						to: "#settings",
						codePropToMatch: "document",
					},
				],
			},
			{
				title: "Email HTML Import",
				icon: "code-tags",
				to: "htmlimport",
			},
		],
	}),
	mutations: {},
	actions: {},
	getters: {
		getMenu(state) {
			return state.menuArr;
		},
	},
};
